import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ChangeContext, Options } from '@angular-slider/ngx-slider';

export enum SliderTypes {
  Competence = 'competence',
  Behavioranchor = 'behavioranchor',
}

@Component({
  selector: 'app-rating-slider',
  templateUrl: './rating-slider.component.html',
  styleUrls: ['./rating-slider.component.scss']
})
export class RatingSliderComponent implements OnInit, OnChanges {

  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() value: number;
  @Input() disabled: boolean | null;
  @Input('hide-value') hideValue: boolean = false;
  @Input() type: SliderTypes = SliderTypes.Competence;

  @Output() valueChange = new EventEmitter<number>();
  @Output() userChange = new EventEmitter<number>();

  options: Options = {};
  SliderTypes = SliderTypes;

  constructor() { }

  ngOnInit(): void {
    this.options = {
      // floor: this.min,
      // ceil: this.max,
      showSelectionBar: true,
      hidePointerLabels: true,
      hideLimitLabels: true,
      showTicks: true,
      disabled: this.disabled,
      animate: false,
      stepsArray: [
        {
          value: -1,
          legend: (this.type === SliderTypes.Competence) ? '-' : null
        }
      ]
    };
    if (this.min >= 0 && this.max >= this.min && this.step > 0) {
      let value = this.min;
      do {
        this.options.stepsArray.push({
          value,
          legend: (this.type === SliderTypes.Competence && Number.isInteger(value)) ? value.toString() : null
        });
        value += this.step;
      } while (value <= this.max);
    }
  }

  ngOnChanges(): void {
    this.options = {...this.options, disabled: this.disabled};
  }

  onValueChange(value: any): void {
    this.valueChange.emit(value);
  }

  onUserChangeEnd(context: ChangeContext): void {
    const selectedValue = this.options.stepsArray.find(value => value.value === context.value);
    this.userChange.emit(selectedValue?.value || -1);
  }

}
